import apiClient, { handleAPIError } from 'helpers/apiService';
import { useAuth } from 'providers/AuthProvider'
import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { Question } from './DataDefinitions';

interface QuestionSearchProps {
    tags: string[];
    onSearch: (questions: Question[], tags: string[]) => void;
    onError: (error: string) => void;
}

const QuestionSearch: React.FC<QuestionSearchProps> = ({ onSearch, onError, tags }) => {

    const auth = useAuth();

    const [searchTerm, setSearchTerm] = useState('');
    const [sortingRule, setSortingRule] = useState('');
    const [searchTag, setSearchTag] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSearch = async (event: React.FormEvent) => {
        event.preventDefault();
        setIsLoading(true);

        try {
            const params = new URLSearchParams({
                query: searchTerm,
                sorting: sortingRule,
                tag: searchTag,
                limit: '10',
                offset: '0'
            });

            const response = await apiClient.get(
                `/v1/forum/search?${params}`,
                {
                    headers: {
                        'accept': 'application/json',

                    },
                    withCredentials: true,
                }
            );
            onSearch(response.data['questions'], response.data['tags']);

        } catch (err) {
            onError(err instanceof Error ? err.message : 'An error occurred');
        } finally {
            setIsLoading(false);
        }
    };

    // Debounced search for real-time results
    useEffect(() => {
        const timer = setTimeout(() => {
            if (searchTerm != null) {
                handleSearch(new Event('submit') as any);
            }
        }, 300);

        return () => clearTimeout(timer);
    }, [searchTerm]);

    useEffect(() => {
        if (sortingRule != "" && searchTag != "")
            handleSearch(new Event('submit') as any);
    }, [sortingRule, searchTag]);


    return (
        <>
            <div className="w-50">
                <form onSubmit={handleSearch}>
                    <div className="input-group">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search questions..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <button
                            className="btn btn-primary"
                            type="submit"
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            ) : (
                                'Search'
                            )}
                        </button>
                    </div>
                </form>

                {/* 
                {error && (
                    <div className="alert alert-danger mt-2" role="alert">
                        {error}
                    </div>
                )}
                */}

            </div>
            <div className="d-flex gap-4 align-items-center w-50">
                <Form.Select className="flex-grow-1" id="sort" name="sort" onChange={(e) => setSortingRule(e.target.value)}>
                    <option>Sort by...</option>
                    <option value="newest">Newest</option>
                    <option value="votes">Most Votes</option>
                    <option value="answers">Most Answers</option>
                </Form.Select>

                <Form.Select id="filter_by_tag" name="filter_by_tag" onChange={(e) => setSearchTag(e.target.value)}>
                    <option>Filter by tag...</option>
                    {tags.map((tag, index) => (
                        <option key={index} value={tag}>{tag}</option>
                    ))}
                </Form.Select>
            </div>
        </>
    );
};

export default QuestionSearch;